/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import React from 'react'

import BarPlotContainer from 'containers/BarPlot'
import PhotoPane from 'components/PhotoPane'
import DocumentsSidebar from 'components/DocumentsSidebar'
import Layout from 'components/Layout'
import Logo from 'components/Logo'
import SiteTitle from 'components/SiteTitle'
import Nav from 'components/Nav'
import Helmet from 'react-helmet'

const BarPlot = ({
  className,
  barPlot,
  documentNavigation,
  barPlotNavigation,
}) => {
  return (
    <Layout gridName="docsGrid" className={className}>
      <Helmet title={barPlot.title} />
      <Logo className="logoRegion" />
      <SiteTitle className="titleRegion" title="651 - Gateway" />
      <Nav className="navRegion" />
      <DocumentsSidebar
        documentNavigation={documentNavigation}
        barPlotNavigation={barPlotNavigation}
        className="sidebarRegion"
      />
      <PhotoPane photo={barPlot} className="fullPaneRegion region" />
    </Layout>
  )
}

export default BarPlotContainer(BarPlot)
